var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGarionix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128.2 31.2",
    style: {
      enableBackground: "new 0 0 128.2 31.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,31.2c0-1.6,0-3.1,0-4.8c3.7,0,7.3,0,11,0c0-0.6,0-1,0-1.6c-2.2,0-4.4,0-6.6,0c-3.3,0-4.5-1.2-4.5-4.5 c0-3,0-6.1,0-9.1C1,9,1.8,7.8,4,7.3c3.2-0.7,6.4-1.4,9.6-2c2.1-0.4,4.1,1.3,4.1,3.5c0,6.4,0,12.7,0,19.1c0,1.9-1.3,2.7-2.8,3.3 C10.3,31.2,5.7,31.2,1,31.2z M12.1,10.7c-1.7,0.4-3.3,0.7-4.8,1c-0.2,0.1-0.6,0.4-0.6,0.6c0,2.5,0,4.9,0,7.4c1.9,0,3.6,0,5.4,0 C12.1,16.7,12.1,13.9,12.1,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.3,24.7c-1.8,0-3.7,0-5.6,0c0-1.9,0-3.6,0-5.5c-1.9,0-3.6,0-5.5,0c0,1.8,0,3.5,0,5.4c-1.9,0-3.7,0-5.5,0 c0-1.9-0.1-3.9,0.1-5.9c0.1-0.8,1-1.5,1.5-2.2c-1-0.3-1.6-1.3-1.6-2.5c-0.1-2,0-4,0-6.1c1.8-0.3,3.6-0.6,5.5-0.9c0,2.4,0,4.7,0,7.1 c1.9,0,3.6,0,5.5,0c0-2.6,0-5.2,0-7.9c2-0.3,3.8-0.7,5.7-1c0,3,0,5.9,0,8.9c-0.5,1.1-0.8,2.2-2.2,2.5c1.4,0.7,1.5,0.8,2.2,2.6 C127.3,21,127.3,22.9,127.3,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.7,0.5c0.1,1.3,0.1,2.5,0.2,3.8c-2,0-3.7,0-5.7,0c0-1.3,0-2.5,0-3.8C59,0.5,60.9,0.5,62.7,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.1,0.5c0,1.2,0,2.5,0,3.8c-1.8,0-3.6,0-5.5,0c0-1.3,0-2.5,0-3.8C104.4,0.5,106.2,0.5,108.1,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,13.9c0-1.1,0-2,0-3.1c-3.7,0.7-7.2,1.5-10.9,2.2c0-1.7,0-3.3,0-5c2.2-0.5,4.5-0.9,6.8-1.4 c1.6-0.3,3.2-0.7,4.8-1c1.3-0.2,2.7-0.3,3.7,0.7c0.6,0.5,1.2,1.4,1.2,2.1c0.1,5.4,0.1,10.8,0.1,16.4c-0.4,0-0.8,0.1-1.2,0.1 c-3.8,0-7.6,0-11.4,0c-2.8,0-4.1-1.3-4.1-4.1c0-1,0-1.9,0-2.9c0-2.4,1.3-3.8,3.7-3.8c2.2,0,4.3,0,6.5,0 C29.9,13.9,30.2,13.9,30.5,13.9z M30.5,18.3c-1.9,0-3.6,0-5.4,0c0,0.5,0,0.9,0.1,1.4c1.8,0,3.6,0,5.4,0 C30.5,19.3,30.5,18.8,30.5,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.7,15c0,2,0,4.1,0,6.1c0,2.1-1.4,3.6-3.5,3.6c-3.3,0.1-6.6,0.1-9.8,0c-2,0-3.4-1.5-3.4-3.5 c0-3.6,0-7.1,0-10.7c0-1.6,0.9-2.8,2.6-3.2c3.3-0.8,6.7-1.5,10.1-2.1C79.8,5,81.7,6.7,81.7,9C81.7,11,81.7,13,81.7,15z M76,19.7 c0-3,0-5.9,0-9c-1.8,0.4-3.5,0.7-5.3,1.1c0,2.7,0,5.2,0,7.9C72.4,19.7,74.1,19.7,76,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.7,5.4c1.8,0,3.5,0,5.4,0c0.1,0.4,0.1,0.8,0.2,1.4c2-0.4,3.9-0.7,5.8-1.1c3.4-0.7,5.2,0.7,5.2,4.2 c0,4.9,0,9.8,0,14.8c-1.9,0-3.6,0-5.5,0c0-4.6,0-9.1,0-13.9c-1.9,0.4-3.7,0.7-5.6,1.1c0,4.3,0,8.5,0,12.8c-1.9,0-3.6,0-5.5,0 C83.7,18.2,83.7,11.8,83.7,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.4,5.4c1.8,0,3.6,0,5.5,0C43.9,5.8,44,6.2,44,6.8C46,6.4,48,6,49.9,5.6c1.5-0.3,3-0.3,4.1,0.9 c0.5,0.5,0.9,1.2,1,1.9c0.1,1.4,0.1,2.9,0,4.3c0,0.2-0.3,0.6-0.5,0.7c-1.6,0.4-3.3,0.7-5.1,1.2c0-1.3,0-2.5,0-3.8 c-1.9,0.4-3.6,0.7-5.5,1.1c0,4.2,0,8.5,0,12.8c-1.9,0-3.7,0-5.6,0C38.4,18.2,38.4,11.8,38.4,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.6,5.4c1.8,0,3.6,0,5.5,0c0,6.5,0,12.9,0,19.3c-1.8,0-3.6,0-5.5,0C102.6,18.3,102.6,11.9,102.6,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.8,24.7c-1.8,0-3.6,0-5.5,0c0-6.4,0-12.7,0-19.2c1.8,0,3.6,0,5.5,0C62.8,11.9,62.8,18.2,62.8,24.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarionix);
export default __webpack_public_path__ + "static/media/garionix.019c29314919b1dd19746e5d62a08216.svg";
export { ForwardRef as ReactComponent };